const FORMSPREE_ENDPOINT = 'https://formspree.io/f/xyzzyqok';
const RECIPIENT_EMAIL = 'manish.simplipixel@gmail.com';

export interface AssessmentFormData {
  firstName: string;
  lastName: string;
  email: string;
  phone: string;
  company: string;
  industry: string;
}

export interface ConsultationFormData {
  name: string;
  email: string;
  phone: string;
  company: string;
  consultationType: string;
  preferredDate: string;
  preferredTime: string;
  meetingType: string;
  challenges?: string;
  goals?: string;
  currentSituation?: string;
}

export const sendAssessmentForm = async (data: AssessmentFormData) => {
  try {
    const response = await fetch(FORMSPREE_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        _subject: 'New Free Assessment Request - 3 Arrows Media',
        _replyto: data.email,
        'First Name': data.firstName,
        'Last Name': data.lastName,
        'Email': data.email,
        'Phone': data.phone,
        'Company': data.company,
        'Industry': data.industry,
        'Form Type': 'Free Assessment',
        'Timestamp': new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to send assessment form');
    }

    return { success: true };
  } catch (error) {
    console.error('Error sending assessment form:', error);
    throw error;
  }
};

export const sendConsultationForm = async (data: ConsultationFormData) => {
  try {
    const response = await fetch(FORMSPREE_ENDPOINT, {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({
        _subject: 'New Consultation Booking - 3 Arrows Media',
        _replyto: data.email,
        'Name': data.name,
        'Email': data.email,
        'Phone': data.phone,
        'Company': data.company,
        'Consultation Type': data.consultationType,
        'Preferred Date': data.preferredDate,
        'Preferred Time': data.preferredTime,
        'Meeting Type': data.meetingType,
        'Challenges': data.challenges || 'Not provided',
        'Goals': data.goals || 'Not provided',
        'Current Situation': data.currentSituation || 'Not provided',
        'Form Type': 'Consultation Booking',
        'Timestamp': new Date().toISOString(),
      }),
    });

    if (!response.ok) {
      throw new Error('Failed to send consultation form');
    }

    return { success: true };
  } catch (error) {
    console.error('Error sending consultation form:', error);
    throw error;
  }
};
